import type { AppThunk } from "@Store/index";
import getExamsPageData from "./getExamsPageData";

const loadData = (props: any): AppThunk[] => {
  const slug = __SERVER__ ? props?.params?.slug : props?.match?.params?.slug;
  const path = __SERVER__ ? props?.req?.path : window.location.pathname;
  const isDraft = path?.startsWith("/drafts-exams/");

  return [
    getExamsPageData({
      slug,
      staticContext: props.staticContext,
      isDraft,
    }),
  ];
};

export default loadData;
